export type BlocksInterestInstance = {
  rLeftmin: number;
  rLeftmax: number;
  rRightmin: number;
  rRightmax: number;
  start: number;
  stop: number;
  rrDuration: number;
  AmplitudeTWave: number;
  AmplitudePWave: number;
  distanceT: number;
  distanceP: number;
  indexPeakWave: number;
};

// The IIFE-assigned constructor pattern below isn't recognized by TS as a real
// constructor signature; callers should read the result as BlocksInterestInstance.
// eslint-disable-next-line import/no-mutable-exports
let BlocksInterest: any;

(function () {
  BlocksInterest = function (
    this: BlocksInterestInstance,
    lmin: number,
    lmax: number,
    rmin: number,
    rmax: number,
    st: number,
    sp: number,
    rr: number,
    amT: number,
    amP: number,
  ) {
    this.rLeftmin = lmin;
    this.rLeftmax = lmax;
    this.rRightmin = rmin;
    this.rRightmax = rmax;

    this.start = st;
    this.stop = sp;

    this.rrDuration = rr;
    this.AmplitudeTWave = amT;
    this.AmplitudePWave = amP;

    this.distanceT = 0;
    this.distanceP = 0;
    this.indexPeakWave = 0;
  };
})();

export { BlocksInterest };
export default { BlocksInterest };
